/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */

import axios from "@/axios.js";
import store from "@/store/store.js";

export default {
  /*setTodoSearchQuery ({ commit }, query) {
    commit('SET_TODO_SEARCH_QUERY', query)
  },
  fetchTasks ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/apps/todo/tasks', { params: {filter: payload.filter} })
        .then((response) => {
          commit('SET_TASKS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchTags ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/apps/todo/tags')
        .then((response) => {
          commit('SET_TAGS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  addTask ({ commit }, task) {
    return new Promise((resolve, reject) => {
      axios.post('/api/apps/todo/tasks/', {task})
        .then((response) => {
          commit('ADD_TASK', Object.assign(task, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateTask ({ commit }, task) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/apps/todo/task/${task.id}`, {task})
        .then((response) => {
          commit('UPDATE_TASK', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },*/

  /*getAllCharacteristics({ commit }) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("characteristic-list/find")
        .then(res => {
          console.log("gac", res);
          resolve(res.data);
        })
        .catch(err => reject(err));
    });
  },*/

  /*getAllCompetencies({ commit }) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("competency-list/find")
        .then(res => {
          console.log("gaco", res);
          resolve(res.data);
        })
        .catch(err => reject(err));
    });
  },*/

  /*getAllProgressMeasures({ commit }) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("progress-measure-list/find")
        .then(res => {
          console.log("gapm", res);
          resolve(res.data);
        })
        .catch(err => reject(err));
    });
  },*/

  addSelectedCharacteristic({ commit }, characteristic) {
    return new Promise((resolve, reject) => {
      commit("ADD_SELECTED_CHARACTERISTIC", characteristic);
      commit("ADD_SKILL_STEP", 2);
      resolve(characteristic);
      return characteristic; // resolve
    });
  },

  removeSelectedCharacteristic({ commit }, characteristic) {
    return new Promise((resolve, reject) => {
      commit("REMOVE_SELECTED_CHARACTERISTIC", characteristic);
      resolve(characteristic);
      return characteristic; // resolve
    });
  },

  getCompetency({ commit }, compId) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("trainee-competencies/get", compId)
        .then(res => {
          // commit("SET_SELECTED_COMPETENCY", competency);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  findCompetency({ commit }, query) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("trainee-competencies/find", query)
        .then(res => {
          // commit("SET_SELECTED_COMPETENCY", competency);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getCompetencyFromList({ commit }, compId) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("competency-list/get", compId)
        .then(res => {
          // commit("SET_SELECTED_COMPETENCY", competency);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  setSelectedCompetency({ commit }, competency) {
    return new Promise((resolve, reject) => {
      commit("SET_SELECTED_COMPETENCY", competency);
      resolve(competency);
      return competency; // resolve
    });
  },

  setInitialLevel({ commit }, initialLevelObj) {
    return new Promise((resolve, reject) => {
      commit("SET_INITIAL_LEVEL", initialLevelObj[0]);
      commit("SET_INITIAL_LEVEL_TEXT", initialLevelObj[1]);
      resolve(initialLevelObj);
      return initialLevelObj;
    });
  },

  setTrainingDuration({ commit }, trainingDuration) {
    return new Promise((resolve, reject) => {
      commit("SET_TRAINING_DURATION", trainingDuration);
      return trainingDuration; // resolve(td)
    });
  },


  addProgressMeasure({ commit }, progressMeasure) {
    return new Promise((resolve, reject) => {
      commit("ADD_PROGRESS_MEASURE", progressMeasure);
      resolve(progressMeasure);
      return progressMeasure; // resolve(td)
    });
  },

  removeProgressMeasure({ commit }, progressMeasure) {
    return new Promise((resolve, reject) => {
      commit("REMOVE_PROGRESS_MEASURE", progressMeasure);
      resolve(progressMeasure);
      return progressMeasure; // resolve
    });
  },

  saveUserSkillPrgms({ commit }, pm) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("trainee-competencies-prgms/create", pm)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  saveUserSkill({ commit }, userSkill) {
    return new Promise((resolve, reject) => {
      const userNewSkill = {
        usersId: userSkill.usersId,
        // characteristic: this.$store.state.addSkill.characteristics,
        competencyId: userSkill.competencyId,
        playerName: userSkill.playerName,
        skill_name:userSkill.skill_name,
        mentorName: userSkill.mentorName,
        progress_measures:userSkill.progress_measures,
        startDate:userSkill.start_date,
        initialLevel: userSkill.initialLevel,
        trainingDuration: userSkill.trainingDuration,
        progressStatus: "in_progress"
      };
      store
        .dispatch("trainee-competencies/create", userNewSkill)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          console.log("error saving skill", err);
          reject(err);
        });
    });
  },
  searchCompetency ({commit}, value) {
    return new Promise((resolve, reject) => {
      commit("SEARCH_COMPETENCY", value)
    })
  },

  destroyState({commit}) {
    return new Promise((resolve, reject) => {
      commit("DESTROY_ADD_SKILL_STEP");
      commit("DESTROY_CHARACTERISTIC");
      commit("DESTROY_SEARCH_COMPETENCY");
      commit("DESTROY_COMPETENCY");
      commit("DESTROY_INITIAL_LEVEL");
      commit("DESTROY_INITIAL_LEVEL_TEXT");
      commit("DESTROY_TRAINING_DURATION");
      commit("DESTROY_PROGRESS_MEASURES");
      commit("DESTROY_CUSTOM_PROGRESS_MEASURES");
      commit("DESTROY_REVIEW_COMPETENCY");
    })
  }
};
